import { SEO } from "../components/SEO";
import { useTranslation } from "../lib/i18n";

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <>
      <SEO title="Page Not Found — Sentinel" description="The page you are looking for does not exist." />
      <section className="section section-dark" style={{ paddingTop: "var(--space-16)", paddingBottom: "var(--space-16)" }}>
        <div className="container text-center">
          <h1 style={{ color: "var(--text-on-dark)", fontSize: "3rem", marginBottom: "1rem" }}>{t("notfound.title")}</h1>
          <p className="lead lead-dark" style={{ marginBottom: "2rem" }}>
            {t("notfound.body")}
          </p>
          <a href="/" className="btn btn-primary btn-lg">{t("cta.returnHome")}</a>
        </div>
      </section>
    </>
  );
}
